module.exports = __webpack_public_path__ + "assets/img/00106.d41a66d1.png";